<div class="h-full flex flex-col">

  <!-- Back link -->
  <div 
    class="cursor-pointer mt-4 mb-6 shrink-0" 
    (click)="onBack()"
  >
    <span class="fa-icons icon-solid icon-angles-left icon-16 mr-2"></span>
    <span class="text-body-2 text-bush-green-140 font-semibold">
      {{ 'iqboost.buttons.backToMain' | translate }}
    </span>
  </div>

  <!-- Main container -->
  <div class="flex flex-col flex-1 w-full h-full border-0 rounded bg-neutral-5 p-4 min-h-0">

    <div class="flex shrink-0 pt-1 mb-5">
      <span class="maximizer-icons icon-iq-boost icon-24 pt-0.5 mr-3"></span>
      <h6>
        {{ 
          (store.useAllHouseholds() ? 'iqboost.report.detailedReportAllHouseholds' : 'iqboost.report.detailedReport') 
            | translate
            | format: {
              title: getPromptName(store.currentPrompt()),
              entry: store.entryDisplayValue()
            }
        }}
      </h6>
    </div>

    <div class="flex-1 overflow-y-auto min-h-0">
      @if (store.loading()) {
        <div class="w-full h-full flex flex-col items-center justify-center">
          <ng-container *ngTemplateOutlet="thinkingTemplate"></ng-container>

          <!-- The report only paints once the JSON is complete; the phase status is the only
               progress the user gets, and it also suppresses the host loading gif. -->
          @if (store.streamingStatusKey(); as statusKey) {
            <div class="flex items-center mt-2">
              <span class="maximizer-icons icon-iq-boost icon-20 mr-2 text-bush-green-140 animate-pulse"></span>
              <span class="text-body-2 font-semibold text-bush-green-140 animate-pulse pt-1">{{ statusKey | translate }}</span>
            </div>
          }
        </div>
      }
      @else {
        <div class="">
          @for (section of aiReportData().sections; track $index) {
            @if (section.cardType === 'list-card') {
              <div class="block">
                <div 
                  class="border rounded-lg border-transparent bg-white p-4 w-full mb-2"
                >
                  <span class="block text-body-2 text-black font-semibold mb-4" [innerHTML]="section.title | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml">
                  </span>
                
                  @for (subSection of section.subSections; track $index) {
                    <div class="flex items-center justify-between mb-2">
                      <span class="text-black" [innerHTML]="subSection.primaryValue | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml">
                      </span>
                    
                      <span class="text-body-2 text-black font-semibold" [innerHTML]="subSection.secondaryValue | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
                    </div>
                  }
                </div>
              </div>
            }
            @else if (section.cardType === 'text-card') {
                <div class="block border rounded-lg border-neutral-20 bg-white px-4 pt-4 pb-1 mb-4">
                  <span class="block text-body-2 text-black font-semibold mb-4" [innerHTML]="section.title | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
          
                  <div class="flex flex-wrap gap-2">
                    @for (subSection of section.subSections; track $index) {
                      <div class="block">
                        <span class="block text-body-2 text-neutral-70 font-normal mb-1" [innerHTML]="subSection.title | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
            
                        <div 
                          [ngClass]="{
                            'block': section.layout === 'horizontal',
                            'flex gap-2 flex-wrap': section.layout === 'vertical',
                          }"
                        >
                          @for (item of subSection.items; track $index) {
                            <div 
                              class="block border rounded-lg border-neutral-20 bg-white px-4 pt-4 pb-2 mb-4"
                              [ngClass]="{
                                'bg-neutral-5': item.severity === 'low',
                                'bg-inserv-5': item.severity === 'medium',
                                'bg-bush-green-10': item.severity === 'high',
                                'mb-2': section.layout === 'vertical',
                                'mr-2': section.layout === 'horizontal' && ($index + 1) !== subSection.items?.length,
                              }"
                            >
                              <div class="flex items-center">
                                <span class="fa-icons icon-solid icon-{{item.icon}} icon-16 mr-3 text-finserv-140"></span>
                                <div class="block">
                                  <span class="block text-body-2 text-neutral-70 font-semibold mb-1" [innerHTML]="item.title | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
                                  <span class="block text-body-2 text-neutral-70 font-normal" [innerHTML]="item.description | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
            }
            @else if (section.cardType === 'progress') {
              <div class="border rounded-lg border-neutral-20 bg-white px-4 pt-4 pb-1">
                <span class="block text-body-2 text-black font-semibold mb-2" [innerHTML]="section.title | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
              
                @for (subSection of section.subSections; track $index) {
                  <div
                    class="flex flex-wrap gap-2"
                    [ngClass]="{
                      'flex-col': section.layout === 'vertical',
                      'flex-row': section.layout === 'horizontal'
                    }"
                  >
                    @for (item of subSection.items; track $index) {
                      <div class="border rounded-lg border-neutral-20 px-4 pt-4 pb-1 mb-2 min-w-[200px] flex-1 sm:flex-none h-20">
                        <div class="flex items-center justify-between mb-4">
                          <span
                            class="block text-body-2 text-neutral-70"
                          >
                            <span class="block text-body-2 text-neutral-70" [innerHTML]="item.title | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
                          </span>
                          <span
                            class="block text-body-2 font-semibold ml-4"
                            [ngClass]="{
                              'text-neutral-70': item.severity === 'normal',
                              'text-error': item.severity === 'low',
                              'text-yellow-100': item.severity === 'medium',
                              'text-finserv-10': item.severity === 'high'
                            }"
                          >
                            {{ item.percentage }}%
                          </span>
                        </div>
                        <div class="w-full h-3 bg-neutral-20 rounded">
                          <div
                            class="h-3 rounded"
                            [ngClass]="{
                              'bg-primary-10': item.severity === 'normal',
                              'bg-error': item.severity === 'low',
                              'bg-yellow-100': item.severity === 'medium',
                              'bg-finserv-10': item.severity === 'high'
                            }"
                            [ngStyle]="{
                              width: (item.percentage > 100 ? 100 : item.percentage) + '%'
                            }"
                          ></div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
              
            }
            @else if (section.cardType === 'value-card') {
              <div class="block mb-4 border rounded-lg border-transparent bg-white px-4 pt-4 pb-1 w-full">
                <span class="block text-body-2 text-black font-semibold mb-2" [innerHTML]="section.title | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
          
                <div 
                  [ngClass]="{
                    'block': section.layout === 'vertical',
                    'flex flex-wrap gap-2': section.layout === 'horizontal',
                  }"
                >
                  @for (subSection of section.subSections; track $index) {
                    <div class="pl-4 pb-2">
                      <span class="block text-body-2 text-black font-normal mb-1" [innerHTML]="subSection.title | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
          
                      <div class='flex flex-wrap gap-2'>
                        @for (item of subSection.items; track $index) {
                          <div 
                            class="border rounded-lg border-neutral-20 bg-white p-4 w-max"
                            [ngClass]="{
                              'bg-neutral-5': item.severity === 'low',
                              'bg-inserv-5': item.severity === 'medium',
                              'bg-bush-green-10': item.severity === 'high',
                            }"
                          >
                            <div class="flex">
                              <span class="fa-icons icon-solid icon-{{item.icon}} icon-16 mr-3 text-finserv-140"></span>
                              <span class="text-body-2 text-neutral-70 font-semibold" [innerHTML]="item.value | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml"></span>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @else {
              <!-- Unknown cardType: say so instead of leaving a hole in the report. -->
              <div class="block border rounded-lg border-neutral-20 bg-white p-4 w-full mb-2">
                <span class="block text-body-2 text-neutral-70 font-normal">
                  {{ 'iqboost.report.unsupportedCard' | translate }}
                </span>
              </div>
            }
          }
        </div>

        <!-- Footer -->
        <div class="grid grid-cols-3 items-center w-full h-[2.625rem] bg-neutral-5 mt-5 px-3">
          <div class="justify-self-start">
            <button
              kendoButton
              themeColor="primary"
              fillMode="flat"
              [disabled]="store.loading()"
              (click)="regenerateReport()"
              class="w-32 h-[34px] rounded"
            >
              <div class="flex items-center">
                <span class="fa-icons icon-solid icon-16 icon-wand-magic-sparkles mr-3"></span>
                {{ 'iqboost.buttons.regenerate' | translate }}
              </div>
            </button>
          </div>

          <div class="justify-self-center">
            @if (store.currentPrompt() && !store.loading()) {
              <ai-feedback
                #feedback
                extraIconClass="icon-light icon-22"
                [source]="tracker.module"
                [disableOnFeedback]="true"
                (feedbackClicked)="store.computeFeedbackDisabled(aiResponseJsonString())"
                [metadata]="{ location: ViewType[store.viewType()] }"
              ></ai-feedback>
            }
          </div>
          <div></div>
        </div>
      }
    </div>
  </div>

  <ng-template #thinkingTemplate>
    <div class="flex flex-col items-center justify-center w-full h-full space-y-2">
      <img
        class="w-[108px]"
        [src]="cdn + '/assets/images/empty-container.svg'"
        alt="Loading…"
      />
    </div>
  </ng-template>

</div>
